'use client';

import { useRouter } from 'next/navigation';
import React from 'react';

export function withAppRouter< P >(Wrapped: React.ComponentType<P & { router: ReturnType<typeof useRouter> }>) {
	return (props: P) => {
		const router = useRouter();
		return <Wrapped {...props} router={router} />;
	};
}
